import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ConfirmDialogComponent } from 'src/app/material-module/confirm-dialog/confirm-dialog.component';
import { StatoIncarico } from 'src/app/models/stato-incarico';
import { StatoIncaricoService } from 'src/app/services/stato-incarico.service';
import { dataTableColumnDefinition } from 'src/app/shared/resourceful-index/dataTableColumnDefinition';
import { ResourcefulIndexComponent } from 'src/app/shared/resourceful-index/resourceful-index/resourceful-index.component';
import { EditStatoIncaricoComponent } from './dialogs/edit/edit.component';

@Component({
  selector: 'stati-incarico',
  templateUrl: './stati-incarico.component.html',
  styleUrls: ['./stati-incarico.component.scss']
})
export class StatiIncaricoComponent implements OnInit {


  headingText: string = 'Stati incarico';

  relations: string[] = [];

  @ViewChild('index') index: ResourcefulIndexComponent;

  multipleSelection: boolean = false;
  selectionMode: boolean = true;
  showReset: boolean = false;
  loading: boolean = true;

  search: any;

  columnDefinitions: dataTableColumnDefinition[] = [
    new dataTableColumnDefinition(
      {
        humanName: 'ID',
        internalName: 'id',

      }
    ),
    new dataTableColumnDefinition(
      {
        humanName: 'Nome',
        internalName: 'nome',

      }
    ),
  ];

  constructor(public statoIncaricoService: StatoIncaricoService,
    public dialog: MatDialog,
    private toast: ToastrService,
    @Optional() private dialogRef: MatDialogRef<StatiIncaricoComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,) {
    if (this.data?.selectionMode || this.data?.multipleSelection) {
      console.log(data);
      this.selectionMode = this.data.selectionMode;
      this.multipleSelection = this.data.multipleSelection;
      this.showReset = this.data.showReset;
      this.headingText = 'Seleziona uno stato di incarico';
    }
  }

  form: FormGroup;
  ngOnInit() {

    this.form = this.fb.group({
      nome: [],
    });

    this.form.valueChanges.subscribe(newValues => {
      this.search = newValues
      console.log(this.search);
    });

  }

  async ngAfterViewInit(): Promise<void> {
    await this.updateDataSource();
    this.loading = false;
  }

  closeDialogWithSelectedModel(model) {
    this.dialogRef?.close(model);
  }

  async updateDataSource() {
    await this.index?.updateData();
  }


  deleteFunction = async (statoIncarico: StatoIncarico) => {
    try {
      let dialogRef = this.dialog.open(ConfirmDialogComponent, { data: { message: `Sei sicuro di voler eliminare lo stato incarico ${statoIncarico.nome}?` } });
      dialogRef.afterClosed().subscribe(async data => {
        if (data) {
          await this.statoIncaricoService.delete(statoIncarico);
          this.toast.success('Stato incarico eliminato.');
          this.updateDataSource();
        }
      });
    } catch (e) {
      console.error(e);
      this.toast.error("Eliminazione Stato incarico fallita.", "Errore!");
    }
  }



  editFunction = async (statoIncarico: StatoIncarico) => {
    try {
      let dialogRef = this.dialog.open(EditStatoIncaricoComponent, { data: statoIncarico });
      dialogRef.afterClosed().subscribe(async (data: StatoIncarico) => {
        if (data) {

          Object.assign(statoIncarico, data);

          await this.statoIncaricoService.edit(statoIncarico);

          this.toast.success('Stato incarico modificato');
          this.updateDataSource();

        }
      });

    } catch (e) {
      console.error(e);
      this.toast.error("Modifica stato incarico fallita.", "Errore!");
    }
  }


  add() {
    let addDialogRef = this.dialog.open(EditStatoIncaricoComponent, { data: this.search });
    addDialogRef.afterClosed().subscribe(data => this.handleCreation(data));
  }

  save() {
    this.dialogRef?.close(this.index?.selection?.selected);
  }

  async handleCreation(statoIncarico?: StatoIncarico) {
    if (statoIncarico) {
      try {
        await this.statoIncaricoService.create(statoIncarico)
        this.toast.success('Stato incarico creato!')
      }
      catch (e) {
        this.toast.error('Creazione stato incarico fallita.', 'Errore!');
      }
      finally {
        this.updateDataSource();
      }

    }
  }



}
